import { FormControl, MenuItem, Select } from "@mui/material";
import { useGlobalLocalContext } from "src/storage/localStorage";

interface AiAssistantGraphDebugProps {
  assistantId: string;
  assistantIds: string[];
  onChange: (assistantId: string) => void;
}

/** Debug-mode only: picks the aegra.json graph the next run uses. */
const AiAssistantGraphDebug = ({
  assistantId,
  assistantIds,
  onChange,
}: AiAssistantGraphDebugProps) => {
  const isDebugMode = useGlobalLocalContext((state) => state.isDebugMode);

  if (!isDebugMode) return null;

  return (
    <div
      className="flex items-center gap-2 pb-2 text-xs text-text-secondary"
      data-test-id="ai-assistant-graph-debug"
    >
      <span className="shrink-0">Graph</span>
      <FormControl size="small">
        <Select
          value={assistantId}
          onChange={(event) => onChange(String(event.target.value))}
          sx={{
            fontSize: "0.75rem",
            "> .MuiSelect-select": { minHeight: 0, padding: "1px 7px" },
          }}
          data-test-id="ai-assistant-graph-select"
        >
          {assistantIds.map((id) => (
            <MenuItem key={id} value={id} sx={{ fontSize: "0.75rem" }}>
              {id}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
};

export default AiAssistantGraphDebug;
